import actions from './actions';

const initState = {
  organizations: null,
  organization: null,
  allorganizations: null,
  key: null,
};

export default function userReducer(state = initState, action) {
  switch (action.type) {
    case actions.GET_ALL_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        allorganizations: action.allorganizations,
      };

    case actions.FETCH_ORGANIZATIONS_SUCCESS:
      return {
        ...state,
        organizations: action.organizations,
      };

    case actions.FETCH_ORGANIZATION_DETAILS_SUCCESS:
      return {
        ...state,
        organization: action.organization,
      };

    case actions.SET_FILTER:
      return {
        ...state,
        key: action.key,
      };

    case actions.RESET:
      return {
        ...state,
        key: null,
      };

    default:
      return state;
  }
}
